import type { ConversationCardSkeletonRendererProps } from 'src/modules/communications/types/conversation-card.type';
import { useClientType } from 'src/modules/shared/hooks/use-client-type';
import { ConversationCardSkeleton } from './card/card-skeleton';
import { LegacyConversationCardSkeleton } from './legacy-card/card-skeleton';

/**
 * Matches the loading placeholder to the tenant's conversation card.
 *
 * @param props - Existing layout and optional wrapper classes.
 * @returns The regular skeleton for real-estate tenants or the legacy skeleton.
 */
export const ConversationCardSkeletonRenderer: React.FC<
  ConversationCardSkeletonRendererProps
> = ({ layout = 'list', className }) => {
  const clientType = useClientType();

  return clientType === 'REAL_ESTATE' ? (
    <ConversationCardSkeleton className={className} />
  ) : (
    <LegacyConversationCardSkeleton layout={layout} className={className} />
  );
};
